import React from 'react';
import Layout from '../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Settings as SettingsIcon, Globe, Bell, Lock } from 'lucide-react';

const Settings = () => {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto space-y-6" data-testid="settings-page">
        <div>
          <h1 className="text-3xl font-heading font-bold text-foreground">Einstellungen</h1>
          <p className="text-muted-foreground mt-1">
            Verwalten Sie Ihre Kontoeinstellungen
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Globe className="w-5 h-5 text-primary" />
              Sprache
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Spracheinstellungen werden in zukünftigen Updates verfügbar sein.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Bell className="w-5 h-5 text-primary" />
              Benachrichtigungen
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Benachrichtigungseinstellungen werden in zukünftigen Updates verfügbar sein.
            </p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Lock className="w-5 h-5 text-primary" />
              Sicherheit
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Sicherheitseinstellungen werden in zukünftigen Updates verfügbar sein.
            </p>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default Settings;
